<script>
    export default {
        data() {
            return {
                personal_tax_ch: [
                    {
                    procent: 0,
                    to: '2300'
 },
                    {
                    procent: 0.06,
                    to: '2350'
 },
                    {
                    procent: 0.40,
                    to: '2400'
 },
                    {
                    procent: 0.65,
                    to: '2450'
 },
                    {
                    procent: 0.89,
                    to: '2500'
 },
                    {
                    procent: 1.12,
                    to: '2550'
 },
                    {
                    procent: 1.34,
                    to: '2600'
 },
                    {
                    procent: 1.55,
                    to: '2650'
 },
                    {
                    procent: 1.75,
                    to: '2700'
 },
                    {
                    procent: 1.98,
                    to: '2750'
 },
                    {
                    procent: 2.19,
                    to: '2800'
 },
                    {
                    procent: 2.40,
                    to: '2850'
 },
                    {
                    procent: 2.60,
                    to: '2900'
 },
                    {
                    procent: 2.82,
                    to: '2950'
 },
                    {
                    procent: 3.03,
                    to: '3000'
 },
                    {
                    procent: 3.23,
                    to: '3050'
 },
                    {
                    procent: 3.43,
                    to: '3100'
 },
                    {
                    procent: 3.64,
                    to: '3150'
 },
                    {
                    procent: 3.84,
                    to: '3200'
 },
                    {
                    procent: 4.05,
                    to: '3250'
 },
                    {
                    procent: 4.24,
                    to: '3300'
 },
                    {
                    procent: 4.44,
                    to: '3350'
 },
                    {
                    procent: 4.65,
                    to: '3400'
 },
                    {
                    procent: 4.85,
                    to: '3450'
 },
                    {
                    procent: 5.04,
                    to: '3500'
 },
                    {
                    procent: 5.23,
                    to: '3550'
 },
                    {
                    procent: 5.41,
                    to: '3600'
 },
                    {
                    procent: 5.59,
                    to: '3650'
 },
                    {
                    procent: 5.76,
                    to: '3700'
 },
                    {
                    procent: 5.93,
                    to: '3750'
 },
                    {
                    procent: 6.10,
                    to: '3800'
 },
                    {
                    procent: 6.26,
                    to: '3850'
 },
                    {
                    procent: 6.43,
                    to: '3900'
 },
                    {
                    procent: 6.60,
                    to: '3950'
 },
                    {
                    procent: 6.77,
                    to: '4000'
 },
                    {
                    procent: 6.93,
                    to: '4050'
 },
                    {
                    procent: 7.09,
                    to: '4100'
 },
                    {
                    procent: 7.25,
                    to: '4150'
 },
                    {
                    procent: 7.40,
                    to: '4200'
 },
                    {
                    procent: 7.55,
                    to: '4250'
 },
                    {
                    procent: 7.70,
                    to: '4300'
 },
                    {
                    procent: 7.86,
                    to: '4350'
 },
                    {
                    procent: 8.01,
                    to: '4400'
 },
                    {
                    procent: 8.16,
                    to: '4450'
 },
                    {
                    procent: 8.31,
                    to: '4500'
 },
                    {
                    procent: 8.45,
                    to: '4550'
 },
                    {
                    procent: 8.59,
                    to: '4600'
 },
                    {
                    procent: 8.73,
                    to: '4650'
 },
                    {
                    procent: 8.87,
                    to: '4700'
 },
                    {
                    procent: 9.02,
                    to: '4750'
 },
                    {
                    procent: 9.17,
                    to: '4800'
 },
                    {
                    procent: 9.32,
                    to: '4850'
 },
                    {
                    procent: 9.47,
                    to: '4900'
 },
                    {
                    procent: 9.61,
                    to: '4950'
 },
                    {
                    procent: 9.75,
                    to: '5000'
 },
                    {
                    procent: 9.89,
                    to: '5050'
 },
                    {
                    procent: 10.03,
                    to: '5100'
 },
                    {
                    procent: 10.17,
                    to: '5150'
 },
                    {
                    procent: 10.30,
                    to: '5200'
 },
                    {
                    procent: 10.44,
                    to: '5250'
 },
                    {
                    procent: 10.57,
                    to: '5300'
 },
                    {
                    procent: 10.70,
                    to: '5350'
 },
                    {
                    procent: 10.83,
                    to: '5400'
 },
                    {
                    procent: 10.95,
                    to: '5450'
 },
                    {
                    procent: 11.07,
                    to: '5500'
 },
                    {
                    procent: 11.20,
                    to: '5550'
 },
                    {
                    procent: 11.32,
                    to: '5600'
 },
                    {
                    procent: 11.44,
                    to: '5650'
 },
                    {
                    procent: 11.56,
                    to: '5700'
 },
                    {
                    procent: 11.68,
                    to: '5750'
 },
                    {
                    procent: 11.80,
                    to: '5800'
 },
                    {
                    procent: 11.91,
                    to: '5850'
 },
                    {
                    procent: 12.02,
                    to: '5900'
 },
                    {
                    procent: 12.13,
                    to: '5950'
 },
                    {
                    procent: 12.24,
                    to: '6000'
 },
                    {
                    procent: 12.34,
                    to: '6050'
 },
                    {
                    procent: 12.45,
                    to: '6100'
 },
                    {
                    procent: 12.55,
                    to: '6150'
 },
                    {
                    procent: 12.66,
                    to: '6200'
 },
                    {
                    procent: 12.76,
                    to: '6250'
 },
                    {
                    procent: 12.86,
                    to: '6300'
 },
                    {
                    procent: 12.95,
                    to: '6350'
 },
                    {
                    procent: 13.05,
                    to: '6400'
 },
                    {
                    procent: 13.15,
                    to: '6450'
 },
                    {
                    procent: 13.24,
                    to: '6500'
 },
                    {
                    procent: 13.33,
                    to: '6550'
 },
                    {
                    procent: 13.43,
                    to: '6600'
 },
                    {
                    procent: 13.51,
                    to: '6650'
 },
                    {
                    procent: 13.60,
                    to: '6700'
 },
                    {
                    procent: 13.69,
                    to: '6750'
 },
                    {
                    procent: 13.77,
                    to: '6800'
 },
                    {
                    procent: 13.86,
                    to: '6850'
 },
                    {
                    procent: 13.94,
                    to: '6900'
 },
                    {
                    procent: 14.02,
                    to: '6950'
 },
                    {
                    procent: 14.10,
                    to: '7000'
 },
                    {
                    procent: 14.18,
                    to: '7050'
 },
                    {
                    procent: 14.26,
                    to: '7100'
 },
                    {
                    procent: 14.34,
                    to: '7150'
 },
                    {
                    procent: 14.34,
                    to: '9999999999999'
                }
                ]
            }
        }
    };
</script>
